import { API } from "../config";
import { CreateCaseTypes, SearchHistoryTypes } from "../types";

export const getAdminDashboardSummary = async () => {
  const response = await API.get("/admin/summary");
  return response?.data?.data;
};
export const getAdminCaseState = async () => {
  const response = await API.get("/admin/stats/case");
  return response?.data?.data;
};
export const getAdminUsers = async (page?: number, type?: string) => {
  const query = new URLSearchParams();

  if (page !== undefined) {
    query.append("page", page.toString());
  }

  if (type !== undefined) {
    query.append("type", type);
  }

  const response = await API.get(`/admin/users?${query.toString()}`);
  return response?.data;
};
export const getAdminUserById = async (id: number | string) => {
  const response = await API.get(`/admin/users/${id}`);
  return response?.data?.data;
};
export const getAllCases = async (page: number) => {
  // const response = await API.get(`/admin/cases?${query.toString()}`);
  const response = await API.get(`/admin/cases?${page}`);
  return response?.data;
};
export const getAllActivityLogs = async (page: number) => {
  const response = await API.get(`/admin/activity/logs?page=${page}`);
  return response?.data;
};
export const getSinglectivityLogs = async (id: number | null) => {
  const response = await API.get(`/admin/activity/logs/${id}`);
  return response?.data?.data;
};

export const getAdminSearchStats = async () => {
  const response = await API.get(`/admin/stats/search`);
  return response?.data;
};

export const createCase = async (data: CreateCaseTypes) => {
  const response = await API.post("/admin/cases", data);
  return response?.data;
};
export const getJudicialDivisionsAdmin = async (page: number) => {
  const response = await API.get(`/admin/judicial-divisions?page=${page}`);
  return response?.data;
};
export const editCase = async (
  data: CreateCaseTypes,
  id: number | undefined | null,
) => {
  const response = await API.post(`/admin/cases/${id}/update`, data);
  return response?.data;
};
export const deleteCase = async (id: number | undefined) => {
  const response = await API.delete(`/admin/cases/${id}`);
  return response?.data;
};
export const addUser = async (data: {
  name: string;
  email: string;
  type: string;
}) => {
  const response = await API.post(`/admin/users`, data);
  return response?.data;
};
export const deleteUser = async (id: number | undefined) => {
  const response = await API.delete(`/admin/users/${id}`);
  return response?.data;
};
export const getPlatformCharge = async () => {
  const response = await API.get(`/settings/show`);
  return response?.data?.data;
};
export const updatePlatformCharge = async (data: FormData) => {
  const response = await API.post(`/admin/settings`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response?.data;
};
export const createLga = async (data: { name: string }) => {
  const response = await API.post(`/admin/states/1/lga`, data);
  return response?.data;
};
export const uploadAdminCsv = async (file: FormData, setProgress: Function) => {
  const response = await API.post(`/admin/cases/csv`, file, {
    headers: { "Content-Type": "multipart/formdata" },
    onDownloadProgress(progressEvent) {
      const total = progressEvent.total || 1;
      const progressCompleted = Math.round(
        (progressEvent.loaded / total) * 100,
      );
      setProgress(progressCompleted);
    },
  });

  return response?.data;
};
export const createJudicialDivision = async (data: { name: string }) => {
  const response = await API.post(`/admin/judicial-divisions`, data);
  return response?.data;
};
export const updateJudicialDivision = async (
  id: number | undefined,
  data: { name: string },
) => {
  const response = await API.post(
    `/admin/judicial-divisions/${id}/update`,
    data,
  );
  return response?.data;
};
export const updateLga = async (
  id: number | undefined,
  data: { name: string },
) => {
  const response = await API.post(`/admin/lga/${id}/update`, data);
  return response?.data;
};
export const deleteLga = async (id: number | undefined) => {
  const response = await API.delete(`/admin/lga/${id}`);
  return response?.data;
};
export const deleteJudicialDivision = async (id: number | undefined) => {
  const response = await API.delete(`/admin/judicial-divisions/${id}`);
  return response?.data;
};

export const updateUserStatus = async (
  userId: number | string,
  data: FormData,
) => {
  const response = await API.post(`/admin/users/${userId}/update`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response?.data;
};
